// 라우트 경로 단일 출처.
//
// App.js 의 선언과 각 화면의 이동 대상을 같은 상수로 묶는다.
// 선언 없는 경로로 이동하면 App.js 의 catch-all 이 조용히 삼켜 엉뚱한 화면이 뜨므로
// (과거 /landing · /loaded 가 만료 화면으로 새던 사고) 양쪽을 한 파일에서 대조 가능하게 둔다.

export const PATH = {
  INIT: '/init',
  INIT2: '/init2',
  TEST: '/test',
  LOADING: '/loading',
  CHAT: '/chat',
  CLOSE: '/close',
  RATING: '/rating',
  MAINTENANCE: '/maintenance',
  EXPIRED: '/expired',
  LOADED: '/loaded',
  LANDING: '/landing',
};

// App.js 의 <Route path> 전용 — 파라미터 패턴 포함
export const ROUTE_PATTERN = {
  LOADING: `${PATH.LOADING}/:fromLanding?`,
  CHAT: `${PATH.CHAT}/:channelId`,
  RATING: `${PATH.RATING}/:channelId`,
};

// 랜딩 단계를 이미 거친 진입. Loading 의 landingRequired 분기를 건너뛴다
export const LOADING_FROM_LANDING = `${PATH.LOADING}/fromLanding`;

// 랜딩을 거치지 않은 일반 진입 (/init · /init2 가 사용)
export const LOADING_FRESH = `${PATH.LOADING}/false`;

export const chatPath = (channelId) => `${PATH.CHAT}/${channelId}`;
export const ratingPath = (channelId) => `${PATH.RATING}/${channelId}`;
